module.exports = __webpack_public_path__ + "static/media/mary-jane-lose.64065262.png";